<template>
<div class="jobs_wrapper" id="top_page">
  <div :class="{'overlay_setting': isLoadingData}">
    <i :class="{'loadding_setting': isLoadingData}"></i>
  </div>
  <div v-if="!isLoadingData">
    <h1 class="jobs_page_title_preview break-word" v-bind:style="{ color: colorSetting.pageText }" v-if="entryPageName">
      {{ entryPageName }}
    </h1>
    <h1 class="jobs_page_title" v-bind:style="{ color: colorSetting.pageText }" v-else>
      {{ labelProperties.ENTRY_PAGE_TITLE }}
    </h1>
    <p class="jobs_table_annotation_preview break-word" v-if="entryPageOverview">{{ entryPageOverview }}</p>
    <div class="entry_stepbar">
      <ul class="entry_stepbar_list" v-bind:style="{ border: '1px solid' + colorSetting.borderColor }">
        <li class="entry_stepbar_item"
            v-bind:style="[step >= 1 ? {backgroundColor: colorSetting.keyColor, '--keyColor': colorSetting.keyColor} : {}]">
          <span class="entry_stepbar_label" v-if="message && message.titleEntry"
                v-bind:style="[step >= 1 ? { color: colorSetting.highlightText } : {}]">
            <span class="title-default">
              {{ message.titleEntry }}
            </span>
            <span class="title-mobile">
              {{ labelProperties.ENTRY_STEP_MOBILE_TITLE }}
            </span>
          </span>
          <span class="entry_stepbar_label" v-else
                v-bind:style="[step >= 1 ? { color: colorSetting.highlightText } : {}]">
            <span class="title-default">
              {{ labelProperties.ENTRY_STEP_TITLE }}
            </span>
            <span class="title-mobile">
              {{ labelProperties.ENTRY_STEP_MOBILE_TITLE }}
            </span>
          </span>
        </li>
        <li class="entry_stepbar_item"
            v-bind:style="[step >= 2 ? {backgroundColor: colorSetting.keyColor, '--keyColor': colorSetting.keyColor} : {backgroundColor: colorSetting.subColor, '--keyColor': colorSetting.subColor}]">
          <span class="entry_stepbar_label" v-if="message && message.titleConfirm"
                v-bind:style="[step >= 2 ? { color: colorSetting.highlightText } : { color: colorSetting.pageText }]">
            <span class="title-default">
              {{ message.titleConfirm }}
            </span>
            <span class="title-mobile">
              {{ labelProperties.CONFIRM_STEP_MOBILE_TITLE }}
            </span>
          </span>
          <span class="entry_stepbar_label" v-else
                v-bind:style="[step >= 2 ? { color: colorSetting.highlightText } : { color: colorSetting.pageText }]">
            <span class="title-default">
              {{ labelProperties.CONFIRM_STEP_TITLE }}
            </span>
            <span class="title-mobile">
              {{ labelProperties.CONFIRM_STEP_MOBILE_TITLE }}
            </span>
          </span>
        </li>
        <li class="entry_stepbar_item"
            v-bind:style="[step >= 3 ? {backgroundColor: colorSetting.keyColor, '--keyColor': colorSetting.keyColor} : { backgroundColor: colorSetting.subColor }]">
          <span class="entry_stepbar_label" v-if="message && message.titleCompletion"
                v-bind:style="[step >= 3 ? { color: colorSetting.highlightText } : { color: colorSetting.pageText }]">
            <span class="title-default">
              {{ message.titleCompletion }}
            </span>
            <span class="title-mobile">
              {{ labelProperties.COMPLETE_STEP_MOBILE_TITLE }}
            </span>
          </span>
          <span class="entry_stepbar_label" v-else
                v-bind:style="[step >= 3 ? { color: colorSetting.highlightText } : { color: colorSetting.pageText }]">
            <span class="title-default">
              {{ labelProperties.COMPLETE_STEP_TITLE }}
            </span>
            <span class="title-mobile">
              {{ labelProperties.COMPLETE_STEP_MOBILE_TITLE }}
            </span>
          </span>
        </li>
      </ul>
    </div>
    <div v-show="step === 1">
      <div id="warning_enter_value">
        <div class="entry_error" v-show="messages && messages.length > 0">
          <p class="entry_error_title">
            {{ messageProperties.ENTRY_ERROR_TITLE }}
          </p>
          <ul class="entry_error_list">
            <li class="entry_error_item" v-for="(message, index) in messages" :key="index">
              <a class="entry_error_link">
                {{ message }}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="categories.length > 0">
        <div v-for="(category, index) in categories" :key="index">
          <div v-if="category && !category.categoryDeleted && !isEmptyCategory(index)" class="mt-2">
            <h2 class="jobs_category_title"
                v-bind:style="{color: colorSetting.pageText, borderLeftColor: colorSetting.keyColor}">
              {{ category.categoryName }}
              <span v-if="category.countCate">
                {{ category.countCate }}
              </span>
            </h2>
            <div class="jobs_table_wrapper">
              <table class="jobs_table" v-for="(item, indexItem) in category.item" :key="indexItem">
                <tbody class="jobs_table_body">
                <tr class="jobs_table_rows" v-if="!isEmptyItem(item)">
                  <th class="jobs_table_head"
                      v-bind:style="[{ backgroundColor: colorSetting.subColor }, indexItem === 0 ? { border: '1px solid' + colorSetting.borderColor } : {borderLeft: '1px solid' + colorSetting.borderColor, borderRight: '1px solid' + colorSetting.borderColor, borderBottom: '1px solid' + colorSetting.borderColor}]">
                    <div class="jobs_table_head_holder">
                        <span class="jobs_table_label" v-bind:style="{ color: colorSetting.pageText }">
                          {{ item.itemName }}
                        </span>
                      <span class="entry_required_label" v-if="item.itemRequired"
                            v-bind:style="{backgroundColor: colorSetting.requiredLabel, color: colorSetting.requiredLabelText}">
                        {{ labelProperties.LABEL_REQUIRE }}
                      </span>
                    </div>
                    <div v-if="item.resourceField.length === 1 && (item.resourceField[0].min_length || item.resourceField[0].max_length)" class="setting_range_allow_input">
                      <span v-if="item.resourceField[0].type === 'textarea' || item.resourceField[0].type === 'text' || item.resourceField[0].type.includes('email') || item.resourceField[0].type === 'tel' || item.resourceField[0].type === 'url'">{{labelProperties.WORD_COUNT}} {{item.resourceField[0].min_length}} ~ {{item.resourceField[0].max_length}}</span>
                      <span v-if="item.resourceField[0].type === 'integer' || item.resourceField[0].type === 'calc' || item.resourceField[0].type === 'number'">{{labelProperties.RANGE}} {{item.resourceField[0].min_length}} ~ {{item.resourceField[0].max_length}}</span>
                    </div>
                  </th>
                  <td class="jobs_table_cell"
                      v-bind:style="[indexItem === 0 ? { border: '1px solid' + colorSetting.borderColor } : {borderLeft: '1px solid' + colorSetting.borderColor, borderRight: '1px solid' + colorSetting.borderColor, borderBottom: '1px solid' + colorSetting.borderColor}]">
                    <div class="jobs_table_form_rows">
                      <div class="jobs_table_form_item">
                        <div v-for="(resourceField, indexResourceField) in buildListItem(item.resourceField)"
                            :key="indexResourceField" class="row">
                          <div class="col" v-for="(resource, indexResource) in resourceField.filter(resourceSetting => resourceSetting && !resourceSetting.isDeletedByMainSystem)" :key="indexResource">
                            <div v-if="resource.type !== 'blank'">
                              <InputComponent
                                class="mt-1"
                                :resource="resource"
                                :master="getMasterData(resource.master_name)"
                                :year="year"
                                :month="month"
                                :day="day"
                                :draftColors="colorSetting"
                                :photo="photo"
                                :itemJob="false"
                                @updatePhoto="updatePhoto"
                                @updateFiles="updateFiles"
                                @updateCheckErrorInput="updateCheckErrorInput"
                                :numberOfItem="item.resourceField.length"
                                :itemName="item.itemName"
                              />
                            </div>
                          </div>
                        </div>
                        <span class="jobs_table_annotation break-word" v-if="item.viewAnnotation && item.annotationText"
                              v-bind:style="{ color: colorSetting.pageText }">
                          ※{{ item.annotationText }}
                        </span>
                      </div>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="setting_unit_add" v-if="index === findLastCategoryIndex('careers')">
              <a class="setting_unit_add_btn" @click.prevent="duplicateCategory(index)">
                {{ labelProperties.DUPLICATE_CARRIER }}
              </a>
            </div>
            <div class="setting_unit_add" v-if="index === findLastCategoryIndex('educations')">
              <a class="setting_unit_add_btn" @click.prevent="duplicateCategory(index)">
                {{ labelProperties.DUPLICATE_EDUCATION }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div v-if="policy.isEnabledPolicy && policy.content !== ''" class="mt-2">
        <h2 class="jobs_category_title"
            v-bind:style="{color: colorSetting.pageText, borderLeftColor: colorSetting.keyColor}">
          {{ labelProperties.PRIVACY_POLICY_CATEGORY }}
        </h2>
        <textarea class="jobs_form_textarea" readonly v-model="policy.content"/>
        <div class="entry_policy_checkbox">
          <label class="jobs_form_label">
            <input type="checkbox" v-model="agreePrivacyPolicy"/>
            <span class="entry_policy_checkbox_text" v-bind:style="{ color: colorSetting.pageText }">
              {{ labelProperties.PRIVACY_POLICY_DEFAULT }}
            </span>
          </label>
        </div>
      </div>
      <div class="entry_policy_checkbox" v-if="policy.isEnabledUrl && policy.textLink !== ''">
        <label class="jobs_form_label">
          <input v-model="agreePrivacyPolicyLink" type="checkbox"/>
          <a :href="policy.url" class="ml-1 mr-3" v-bind:style="{ color: colorSetting.linkText }" target="_blank">
            {{ policy.textLink }}
          </a>
        </label>
      </div>
      <div class="jobs_btn_box">
        <button class="jobs_btn_primary" @click="nextStep(2)"
                :class="isAgreePrivacy() && countInputError === 0 ? '' : 'jobs_btn_disabled'"
                v-bind:style="{color: colorSetting.mainButtonText, backgroundColor: colorSetting.mainButton, border: '1px solid' + colorSetting.borderColor}">
          <span v-if="!button.confirmButton">
            {{ labelProperties.CONFIRM_BUTTON }}
          </span>
          <span v-else>
            {{ button.confirmButton }}
          </span>
        </button>
      </div>
    </div>

    <div v-show="step === 2">
      <div class="entry_confirm">
        <pre class="entry_confirm_text customize_setting_entry_confirm"
             v-if="message && message.messageConfirm">{{ message.messageConfirm }}</pre>
      </div>
      <div v-if="categories.length > 0">
        <div v-for="(category, index) in categories" :key="index">
          <div v-if="category && !category.categoryDeleted && !isEmptyCategory(index)" class="mt-2">
            <h2 class="jobs_category_title"
                v-bind:style="{color: colorSetting.pageText, borderLeftColor: colorSetting.keyColor}">
              {{ category.categoryName }}
              <span v-if="category.countCate">
                {{ category.countCate }}
              </span>
            </h2>
            <div class="jobs_table_wrapper">
              <table class="jobs_table" v-for="(item, indexItem) in category.item" :key="indexItem">
                <tbody class="jobs_table_body">
                <tr class="jobs_table_rows" v-if="!isEmptyItem(item)">
                  <th class="jobs_table_head"
                      v-bind:style="[{ backgroundColor: colorSetting.subColor }, indexItem === 0 ? { border: '1px solid' + colorSetting.borderColor } : {borderLeft: '1px solid' + colorSetting.borderColor, borderRight: '1px solid' + colorSetting.borderColor, borderBottom: '1px solid' + colorSetting.borderColor}]">
                    <div class="jobs_table_head_holder">
                      <span class="jobs_table_label" v-bind:style="{ color: colorSetting.pageText }">
                        {{ item.itemName }}
                      </span>
                      <span class="entry_required_label" v-if="item.itemRequired"
                            v-bind:style="{backgroundColor: colorSetting.requiredLabel, color: colorSetting.requiredLabelText}">
                        {{ labelProperties.LABEL_REQUIRE }}
                      </span>
                    </div>
                    <div v-if="item.resourceField.length === 1 && (item.resourceField[0].min_length || item.resourceField[0].max_length)" class="setting_range_allow_input">
                      <span v-if="item.resourceField[0].type === 'textarea' || item.resourceField[0].type === 'text' || item.resourceField[0].type.includes('email') || item.resourceField[0].type === 'tel' || item.resourceField[0].type === 'url'">{{labelProperties.WORD_COUNT}} {{item.resourceField[0].min_length}} ~ {{item.resourceField[0].max_length}}</span>
                      <span v-if="item.resourceField[0].type === 'integer' || item.resourceField[0].type === 'calc' || item.resourceField[0].type === 'number'">{{labelProperties.RANGE}} {{item.resourceField[0].min_length}} ~ {{item.resourceField[0].max_length}}</span>
                    </div>
                  </th>
                  <td class="jobs_table_cell"
                      v-bind:style="[indexItem === 0 ? { border: '1px solid' + colorSetting.borderColor } : {borderLeft: '1px solid' + colorSetting.borderColor, borderRight: '1px solid' + colorSetting.borderColor, borderBottom: '1px solid' + colorSetting.borderColor}]">
                    <div class="jobs_table_form_rows">
                      <div class="jobs_table_form_item">
                        <div v-for="(resourceField, indexResourceField) in buildListItem(item.resourceField)"
                             :key="indexResourceField" class="row">
                          <div class="col" v-for="(resource, indexResource) in resourceField.filter(resourceSetting => resourceSetting && !resourceSetting.isDeletedByMainSystem)" :key="indexResource">
                            <div v-if="resource.type !== 'blank'">
                              <span
                                v-if="(resource.type === 'single_select' || resource.type === 'select' || resource.type === 'radio') && resource.name !== 'sex_id' && resource.default_value"
                                v-text="resource.default_value.choiceDisplayName ? resource.default_value.choiceDisplayName : resource.default_value.choiceName">
                              </span>
                              <span
                                v-else-if="resource.master_name !== null && (resource.type === 'boolean' || resource.name === 'sex_id') && resource.default_value"
                                v-text="resource.default_value.choiceDisplayName ? resource.default_value.choiceDisplayName : resource.default_value.choiceName">
                              </span>
                              <span v-else-if="TYPE_OF_MULTI_SELECT.includes(resource.type)">
                                {{ getFormatMultiSelect(resource.default_value) }}
                              </span>
                              <span v-else-if="FORMAT_DATE.includes(resource.type) && resource.default_value">
                                {{ getDatetimeString(resource.type, resource.default_value) }}
                              </span>
                              <span v-else-if="resource.name === 'birth_date' && resource.type === 'date' && resource.default_value">
                                {{ getFormatBirthDate(resource.default_value) }}
                              </span>
                              <pre class="pre-margin-bottom" v-else-if="resource.type === 'textarea'">{{ resource.default_value }}</pre>
                              <div v-else-if="resource.name === 'photo'">
                                <div class="entry_uploader_item_img">
                                  <div class="entry_uploader_holder" v-if="photo && photo.name">
                                    <p class="entry_uploader_number" v-if="!photo || !photo.name"
                                       v-bind:style="{color: colorSetting && colorSetting.pageText ? colorSetting.pageText : ''}">
                                      {{ labelsInputProperties.FILE }}:
                                    </p>
                                    <p class="entry_uploader_name ml-2" v-if="photo && photo.name">
                                      {{ photo.name }}
                                    </p>
                                    <p class="entry_uploader_name ml-2 is_disabled" v-else>
                                      {{ labelsInputProperties.NOT_SELECTED_FILE }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div v-else-if="resource.name === 'files'">
                                <div v-for="(file, index) in files" :key="index">
                                  <div class="entry_uploader_item" v-if="file.content && file.content.name">
                                    <div class="entry_uploader_holder">
                                      <p class="entry_uploader_number" v-if="!file || !file.content.name"
                                         v-bind:style="{color: colorSetting && colorSetting.pageText ? colorSetting.pageText : ''}">
                                        {{ file.name + (index + 1) }}:
                                      </p>
                                      <p class="entry_uploader_name ml-2" :class="index > 0 ? 'mt-3' : ''">
                                        {{ file.content.name }}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <span v-else-if="TYPE_OF_NUMBER.includes(resource.type)">
                                {{formatNumberByStep(resource.default_value, resource.step)}}
                              </span>
                              <span class="break-word" v-else>
                                {{ resource.default_value }}
                              </span>
                              <span v-if="resource.unit && resource.default_value" class="ml-1" :class="{'label_unit_item_long': resource.unit.length > userConfig.UNIT_LENGTH, 'label_unit_item': resource.unit.length <= userConfig.UNIT_LENGTH}">{{ resource.unit }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div v-if="policy.isEnabledPolicy && policy.content !== ''" class="mt-2">
        <h2 class="jobs_category_title"
            v-bind:style="{color: colorSetting.pageText, borderLeftColor: colorSetting.keyColor}">
          {{ labelProperties.PRIVACY_POLICY_CATEGORY }}
        </h2>
        <textarea class="jobs_form_textarea" readonly v-model="policy.content"/>
        <div class="entry_policy_checkbox">
          <label class="jobs_form_label">
            <input type="checkbox" v-model="agreePrivacyPolicy" disabled/>
            <span class="entry_policy_checkbox_text" v-bind:style="{ color: colorSetting.pageText }">
              {{ labelProperties.PRIVACY_POLICY_DEFAULT }}
            </span>
          </label>
        </div>
      </div>
      <div class="entry_policy_checkbox" v-if="policy.isEnabledUrl && policy.textLink !== ''">
        <label class="jobs_form_label">
          <input v-model="agreePrivacyPolicyLink" type="checkbox" disabled/>
          <a :href="policy.url" class="ml-1 mr-3" v-bind:style="{ color: colorSetting.linkText }" target="_blank">
            {{ policy.textLink }}
          </a>
        </label>
      </div>
      <div class="jobs_btn_box">
        <button class="jobs_btn_secondary" @click="backStep(1)"
                v-bind:style="{color: colorSetting.subButtonText, backgroundColor: colorSetting.subButton, border: '1px solid' + colorSetting.borderColor}">
          <span v-if="!button.returnButton">
            {{ labelProperties.BACK_BUTTON }}
          </span>
          <span v-else>
            {{ button.returnButton }}
          </span>
        </button>
        <button class="jobs_btn_primary" @click.once="nextStep(3)"
                v-bind:style="{color: colorSetting.mainButtonText, backgroundColor: colorSetting.mainButton, border: '1px solid' + colorSetting.borderColor}">
          <span v-if="!button.entryButton">
            {{ labelProperties.ENTRY_BUTTON }}
          </span>
          <span v-else>
            {{ button.entryButton }}
          </span>
        </button>
      </div>
    </div>

    <div v-show="step === 3">
      <div class="entry_complete">
        <p class="entry_complete_title">
          <span v-if="message && message.messageTitleCompletion">
            {{ message.messageTitleCompletion }}
          </span>
          <span v-else>
            {{ labelProperties.MESSAGE_TITLE_COMPLETION_DEFAULT }}
          </span>
        </p>
        <pre class="entry_complete_text customize_setting_entry_confirm mt-5"
             v-if="message && message.messageBodyCompletion">{{ message.messageBodyCompletion }}</pre>
        <p class="entry_complete_text mt-5" v-else>
          {{ labelProperties.MESSAGE_CONTENT_1 }}
          <br/>
          {{ labelProperties.MESSAGE_CONTENT_2 }}
        </p>
        <div class="jobs_btn_box mt-5">
          <button class="jobs_btn_secondary" v-if="jobDetailId > 0" @click="backToJobDetail(jobDetailId)"
                  v-bind:style="{color: colorSetting.subButtonText, backgroundColor: colorSetting.subButton, border: '1px solid' + colorSetting.borderColor}">
            <span>
              {{ labelProperties.BUTTON_BACK_TO_JOB_DETAIL }}
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="setting_botton_top" ref="ref_botton_top">
    <button v-bind:style="{color: colorSetting.mainButtonText, backgroundColor: colorSetting.mainButton, border: '1px solid' + colorSetting.borderColor}" class="setting_btn_primary" @click="onTopPage">
      <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 320 512" height="1em" width="1em"><path d="M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"></path></svg>
    </button>
  </div>
  <div class="setting_btn_print" v-if="isDisplayPrint">
    <button v-bind:style="{color: colorSetting.mainButtonText, backgroundColor: colorSetting.mainButton, border: '1px solid' + colorSetting.borderColor}" class="setting_btn_primary" @click="printPage()">
      <svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect></svg>
    </button>
  </div>
</div>
</template>

<script>
import Vue from "vue";
import InputComponent from "../CommonSettings/GeneralComponents/InputComponent.vue";
import VueToast from "vue-toast-notification";
import labelProperties from "../../properties/entry_screen/customize_tab/popup-customize/popup-customize-labels.json";
import messageProperties from "../../properties/entry_screen/customize_tab/popup-customize/popup-customize-message.json";
import masterSettingService from "../../services/MasterSettingsService";
import entrySettingNotificationProperty from "../../properties/entry_screen/notifications.json";
import formSettingService from "../../services/FormSettingService";
import entrySettingProperty from "../../properties/entry_screen/entry_screen.json"
import "vue-toast-notification/dist/theme-sugar.css";
import moment from "moment";
import momenttz from "moment-timezone";
import userService from "../../services/UserService";
import labelsInputProperties from "../../properties/input_component/input-component-labels.json";
import configProperties from "../../properties/user_entry_screen/config.json"
import userConfig from "../../properties/user_entry_screen/config.json";
import jobSettingProperty from "../../properties/job_screen/job-screen.json";
import authService from "../../services/AuthService";
import Utils from "../../Utils";
Vue.use(VueToast);

const entryFormType = 0;
const DETAIL_FORM_TYPE = 2;
const DISPATCH_DETAIL_FORM_TYPE = 6;
export default {
  name: "EntryPage",
  components: {
    InputComponent,
  },
  props: [
    "groupName",
    "commonSetting",
    "encryptJobCode",
    "hash",
    "TYPE_OF_SINGLE_SELECT",
    "TYPE_OF_MULTI_SELECT",
    "FORMAT_DATE",
    "TYPE_OF_NUMBER",
    "resourcesAPI",
    "getDatetimeString",
    "formatNumberByStep",
    "isDisplayPrint"
  ],
  data: function () {
    return {
      messages: [],
      master: [],
      step: 1,
      resource: {},
      agreePrivacyPolicy: false,
      agreePrivacyPolicyLink: false,
      isDisableEditing: false,
      year: "",
      month: "",
      day: "",
      categories: [],
      colorSetting: {},
      messageSettings: {},
      message: {},
      policySettings: [],
      policy: {},
      masters: [],
      buttonSettings: {},
      entryPageName: "",
      entryPageOverview : "",
      labelProperties: labelProperties,
      messageProperties: messageProperties,
      labelsInputProperties: labelsInputProperties,
      configProperties: configProperties,
      userConfig: userConfig,
      jobSettingProperty: jobSettingProperty,
      photo: "",
      files: [
        {
          content: "",
          fileBase64: "",
        },
        {
          content: "",
          fileBase64: "",
        },
        {
          content: "",
          fileBase64: "",
        },
      ],
      candidateId: null,
      photoBase64: "",
      keyMasters: [],
      submitCandidateSucces: false,
      displaySetting: {},
      button: {
        entryButton: "",
        confirmButton: "",
        returnButton: "",
      },
      replaceMailSetting: [],
      mailSetting: [],
      autoMailReply: {
        emailAccounts: [],
        emailBody: "",
        emailTitle: "",
      },
      notificationEmail: {
        emailTitle: "",
        errorEmailTitle: "",
        emailAccounts: [],
      },
      jobDetail: {},
      emailToCandidate: {},
      emailToManager: {},
      startActionLog: "User entry page-Click button ",
      data: {},
      isLoadingData: false,
      countInputError: 0,
      itemChecks: [],
      numberOfItem:0,
      itemsJobDetails:[],
      staff:{},
      company:{},
      timer:false,
      next_step: 0,
      keyRedisSearch: "",
      jobDetailId: -1,
      jt: -1,
      masterApiData: [],
    };
  },
  async created() {
    this.isLoadingData = true;
    await this.getPageStatus();
    if (this.commonSetting && this.commonSetting.entryPageName) {
      this.entryPageName = this.commonSetting.entryPageName;
    }

    if (this.commonSetting && this.commonSetting.entryPageOverview) {
      this.entryPageOverview = this.commonSetting.entryPageOverview;
    }

    document.title = labelProperties.PAGE_TITLE;
    this.keyRedisSearch = this.$route.query.query;
    this.jobDetailId = this.$route.query.jid ? Number(this.$route.query.jid) : -1;
    this.jt = Number(this.$route.query.jt);
    await this.getDataSettingEntryForm(entryFormType, this.hash);
    await this.getJobDetailFormDataSetting(this.hash);
    this.getKeyMasterUsed();
    await this.getMastersByCategorySetting(this.keyMasters, this.hash);
    if(!this.isLoadingData){
      this.resizeIframe();
    }

    document.body.style.backgroundColor = this.colorSetting.pageBackground ? this.colorSetting.pageBackground :"#FFFF";
    this.loadResized();
    document.body.addEventListener('scroll', (e) => {
      if (this.$refs.ref_botton_top) {
        this.$refs.ref_botton_top.style.display = "none";
        if (e.target.scrollTop > 20) {
          this.$refs.ref_botton_top.style.display = "block";
        }
      }
    });
  },
  updated() {
    if(this.next_step === 3){
      if(this.submitCandidateSucces){
        this.resizeIframe();
      }
    }else{
      this.resizeIframe();
    }
    window.onresize = () => {
      this.loadResized();
    };
  },
  methods: {
    loadResized(){
      if (this.timer !== false) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.resizeIframe() , 200);
      let windowWidth = window.innerWidth;
      document.body.className = (windowWidth >= 768) ? "scroll-bar print-body-pc": "scroll-bar";
    },
    resizeIframe(){
      let elementResize = document.getElementById("resize_iframe");
      if(window.parent && elementResize){
        let heightPage = elementResize.clientHeight;
        window.parent.postMessage(["resized", {height: heightPage}], "*");
      }
    },

    isAgreePrivacy(){
      if(this.policy.isEnabledUrl && this.policy.isEnabledPolicy){
        return this.agreePrivacyPolicyLink && this.agreePrivacyPolicy;
      }else if(this.policy.isEnabledUrl || this.policy.isEnabledPolicy){
        return this.agreePrivacyPolicyLink || this.agreePrivacyPolicy;
      }else{
        return true;
      }
    },

    isEmptyCategory(index) {
      if (this.categories[index].item.length === 0) {
        return true;
      }

      return this.categories[index].item.filter(item => !this.isEmptyItem(item)).length === 0;
    },

    isEmptyItem(item) {
      if (item.resourceField.length === 1) {
        return item.resourceField[0].isDeletedByMainSystem;
      }

      if (item.resourceField.length > 1) {
        let numberItemDeleted = item.resourceField.filter(resourceSetting => resourceSetting && resourceSetting.isDeletedByMainSystem).length;
        return numberItemDeleted >= item.resourceField.length;
      }

      return true;
    },

    updatePhoto(file) {
      this.photo = file;
    },

    updateCheckErrorInput(resource){
      this.countInputError = 0;
      let checkIncludeItem = this.itemChecks.some(item => item && (item.name === resource.name || item.display_name === resource.display_name));
      if(!checkIncludeItem){
        this.itemChecks.push(resource);
      }
      if(this.itemChecks.length <= 0){
        return;
      }
      this.countInputError = this.itemChecks.filter(itemCheck => itemCheck && (itemCheck.isWrongValue || itemCheck.isWrongFormat|| itemCheck.isWrongDecimalPoint)).length;
    },

    updateFiles(file, type) {
      switch (type) {
        case 0:
          this.files[0].content = file;
          break;
        case 1:
          this.files[1].content = file;
          break;
        case 2:
          this.files[2].content = file;
          break;
      }
    },

    getFormatMultiSelect(values) {
      if (!values || values.length <= 0) {
        return "";
      }

      let optionValues = [];
      values.filter((value) => value.show).forEach(value => {
        if (value.choiceDisplayName) {
          optionValues.push(value.choiceDisplayName);
        } else {
          optionValues.push(value.choiceName);
        }
      });

      return optionValues.join(", ");
    },

    getFormatBirthDate(value) {
      let birthDate = new Date(value);
      let yearString = birthDate.getYear() + 1900;
      yearString = yearString + labelsInputProperties.YEAR;
      let monthString = birthDate.getMonth() + 1;
      monthString = monthString + labelsInputProperties.MONTH;
      let dateString = birthDate.getDate();
      dateString = dateString + labelsInputProperties.DAY;
      return yearString + monthString + dateString;
    },

    async getDataSettingEntryForm(type, hash) {
      await formSettingService.getFormSettingByType(type, hash).then(response => {
        if (!response.data || !response.data.id) {
          return;
        }

        this.data = response.data;
        this.categories = response.data.categorySetting;
        this.colorSetting = response.data.customizeSetting;
        this.buttonSettings = response.data.buttonSetting;
        this.messageSettings = response.data.messageSetting;
        this.policySettings = response.data.policySetting;
        this.displaySetting = response.data.displaySetting;
        this.mailSetting = response.data.mailSetting;
        if(this.jobDetailId > 0) {
          if(this.jt === DISPATCH_DETAIL_FORM_TYPE) {
            this.replaceMailSetting = response.data.replaceMailSettingDispatch;
          } else {
            this.replaceMailSetting = response.data.replaceMailSettingJob;
          }
        } else {
          this.replaceMailSetting = response.data.replaceMailSetting;
        }

        this.handlePolicyOutData();
        this.handleMessageOutData();
        this.handleButtonOutData();
        this.handleMailOutData();
        this.handleUpdateDisplayPrint();
      }).catch(e => {
        console.log(e);
      });
    },

    handleUpdateDisplayPrint(){
      let settingPrint = this.displaySetting && this.displaySetting.print ? this.displaySetting.print: false;
      this.$emit("syncCheckDisplayPrint", settingPrint);
    },

    async getJobDetailFormDataSetting(hash) {
      if(this.jobDetailId <= 0) return;
      const ft = (this.jt === DISPATCH_DETAIL_FORM_TYPE) ? DISPATCH_DETAIL_FORM_TYPE : DETAIL_FORM_TYPE;
      await formSettingService.getFormSettingByType(ft, hash).then(response => {
        if (!response || !response.data || !response.data.id) {
          return;
        }
        this.itemsJobDetails = response.data.categorySetting;
      }).catch(e => {
        console.log(e);
      });
    },

    handleMailOutData() {
      const notificationEmail = this.mailSetting.filter(f => f.emailType === 1)[0];
      if(!notificationEmail) return;
      this.notificationEmail = notificationEmail;
      this.autoMailReply.errorEmailTitle = notificationEmail.errorEmailTitle;
      this.mailSetting.forEach(mail => {
        if(mail.emailType === 0) {
          this.autoMailReply.emailTitle = mail.emailTitle;
          this.autoMailReply.emailBody = mail.emailBody;
        }
        if(mail.emailType === 2 && this.jobDetailId > 0 && this.jt===DETAIL_FORM_TYPE) {
          this.autoMailReply.emailBody = mail.emailBody;
        }
        if(mail.emailType === 3 && this.jobDetailId > 0 && this.jt===DISPATCH_DETAIL_FORM_TYPE) {
          this.autoMailReply.emailBody = mail.emailBody;
        }
        this.autoMailReply.emailAccounts = mail.emailType === 0 ? mail.emailAccounts: this.autoMailReply.emailAccounts;
      });
    },

    handleButtonOutData() {
      this.buttonSettings.forEach(btn => {
        switch (btn.buttonType) {
          case 0:
            this.button.entryButton = btn.buttonName;
            break;
          case 1:
            this.button.confirmButton = btn.buttonName;
            break;
          case 2:
            this.button.returnButton = btn.buttonName;
            break;
        }
      });
    },

    handlePolicyOutData() {
      this.policySettings.forEach(policy => {
        if (policy.privacyPolicyType === 0) {
          this.policy.content = policy.privacyPolicy;
          this.policy.isEnabledPolicy = policy.enable;
        }

        if (policy.privacyPolicyType === 1) {
          this.policy.url = policy.urlLink;
          this.policy.textLink = policy.link;
          this.policy.isEnabledUrl = policy.enable;
        }
      });
    },

    handleMessageOutData() {
      this.messageSettings.forEach(msg => {
        switch (msg.wordingType) {
          case 0:
            this.message.titleEntry = msg.stepTitle;
            break;
          case 1:
            this.message.titleConfirm = msg.stepTitle;
            this.message.messageConfirm = msg.message;
            break;
          case 2:
            this.message.titleCompletion = msg.stepTitle;
            this.message.messageTitleCompletion = msg.messageTitle;
            this.message.messageBodyCompletion = msg.message;
            break;
          case 3:
            this.message.messageError = msg.message;
            break;
        }
      });
    },

    getKeyMasterUsed() {
      if (this.categories.length <= 0) {
        return;
      }

      this.keyMasters = [];
      this.categories.filter(category => category.item && category.item.length > 0 && !category.categoryDeleted).forEach(category =>
        category.item.filter(item => item.resourceField && item.resourceField.length > 0 && !item.itemDeleted).forEach(item =>
          item.resourceField.filter(resource => !resource.isDeletedByMainSystem && resource.master_name).forEach(resource => {
              if (!this.keyMasters.some(key => key === resource.master_name)) {
                this.keyMasters.push(resource.master_name);
              }
            }
          )
        )
      );

      if (this.itemsJobDetails.length <= 0) {
        return;
      }

      this.itemsJobDetails.forEach(category => {
        category.item.filter(item => item.resourceField && item.resourceField.length > 0).forEach(item => {
          item.resourceField.filter(resource => !resource.isDeletedByMainSystem && resource.master_name).forEach(resource => {
            if (!this.keyMasters.some(key => key === resource.master_name)) {
              this.keyMasters.push(resource.master_name);
            }
          });
        });
      });
    },

    async getMastersByCategorySetting(keys, hash) {
      if (keys.length <= 0) {
        this.isLoadingData = false;
        return;
      }
      await masterSettingService.getMastersByCategorySetting(keys, hash).then(response => {
        if (response && response.data != null) {
          this.masters = response.data;
        }
      }).catch(e => {
        console.log(e);
      }).finally(() => {
        this.isLoadingData = false;
      });
    },

    async backStep(step) {
      await this.$emit("createLogger", this.startActionLog + (this.button.returnButton !== "" ? this.button.returnButton : labelProperties.BACK_BUTTON));
      this.handleBindDate();
      this.step = step;
      this.onTopOfIframe();
    },

    async nextStep(nextStep) {
      this.next_step = nextStep;
      switch (nextStep) {
        case 2:
          await this.$emit("createLogger", this.startActionLog + (this.button.confirmButton !== "" ? this.button.confirmButton : labelProperties.CONFIRM_BUTTON));
          break;
        case 3:
          await this.$emit("createLogger", this.startActionLog + (this.button.entryButton !== "" ? this.button.entryButton : labelProperties.ENTRY_BUTTON));
          break;
      }

      this.messages = [];
      if (this.validatorInput()) {
        this.handleBindDate();
        this.isDisableEditing = true;
        if (nextStep === 3) {
          this.isLoadingData = true;
          await this.handleSubmitCandidatesInfo(this.hash);
          if (this.submitCandidateSucces) {
            this.step = nextStep;
            setTimeout(() => {
              this.redirectToEntryComplete();
            }, 5000);
          }
        } else {
          this.step = nextStep;
        }

        document.getElementById("top_page").scrollIntoView();
      } else {
        document.getElementById("top_page").scrollIntoView();
        return this.messages;
      }
      this.onTopOfIframe();
    },

    onTopOfIframe(){
      window.parent.postMessage(["onTopIframe", {}], "*");
    },

    redirectToEntryComplete() {
      if (this.commonSetting.entryCompletionURL && this.commonSetting.entryCompletionURL !== "") {
        window.location = this.commonSetting.entryCompletionURL;
      }
    },

    handleDataCandidateSpecial(dispatchResource, resource){
      let resourceDispatchInsurance = resource.name.slice(resource.name.indexOf(".") + 1, resource.name.length);
      if (this.TYPE_OF_SINGLE_SELECT.includes(resource.type) || this.TYPE_OF_MULTI_SELECT.includes(resource.type)) {
        dispatchResource[`${resourceDispatchInsurance}`] = resource.value;
      } else {
        dispatchResource[`${resourceDispatchInsurance}`] = `${resource.default_value}`;
      }
    },

    async handleSubmitCandidatesInfo(hash) {
      if(!this.categories || this.categories.length === 0){
        this.isLoadingData = false;
        return;
      }
      let dataCandidate = {
        candidate: {},
      };

      let dispatchBasic = {};
      let dispatchInsurance = {};

      this.categories.filter(category => category.item && category.item.length > 0).forEach(category => {
        if (category.item[0].resourceField[0] && category.item[0].resourceField[0].name.includes("educations.")) {
          if (!dataCandidate.candidate.educations) {
            dataCandidate.candidate.educations = [];
          }

          let education = {};
          category.item.filter(item => item.resourceField && item.resourceField.length > 0).forEach(item =>
              item.resourceField.filter(resource => resource.default_value && !resource.isDeletedByMainSystem).forEach(resource => {
                this.formatDataToSubmit(resource);
                if (resource.name && resource.name.includes("educations.")) {
                  let resourceEducation = resource.name.slice(resource.name.indexOf(".") + 1, resource.name.length);
                  if (this.TYPE_OF_SINGLE_SELECT.includes(resource.type) || this.TYPE_OF_MULTI_SELECT.includes(resource.type)) {
                    education[`${resourceEducation}`] = resource.value;
                  } else {
                    education[`${resourceEducation}`] = `${resource.default_value}`;
                  }
                }
              })
          );

          dataCandidate.candidate.educations.push(education);
        } else if (category.item[0].resourceField[0] && category.item[0].resourceField[0].name.includes("careers.")) {
          if (!dataCandidate.candidate.careers) {
            dataCandidate.candidate.careers = [];
          }

          let career = {};
          category.item.filter(item => item.resourceField && item.resourceField.length > 0).forEach(item =>
              item.resourceField.filter(resource => resource.default_value && !resource.isDeletedByMainSystem).forEach(resource => {
                this.formatDataToSubmit(resource);
                if (resource.name && resource.name.includes("careers.")) {
                  let resourceCareer = resource.name.slice(resource.name.indexOf(".") + 1, resource.name.length);
                  if (this.TYPE_OF_SINGLE_SELECT.includes(resource.type) || this.TYPE_OF_MULTI_SELECT.includes(resource.type)) {
                    career[`${resourceCareer}`] = resource.value;
                  } else {
                    career[`${resourceCareer}`] = `${resource.default_value}`;
                  }
                }
              })
          );

          dataCandidate.candidate.careers.push(career);
        } else {
          category.item.filter(item => item.resourceField && item.resourceField.length > 0).forEach(item =>
              item.resourceField.filter(resource => resource.default_value && !resource.isDeletedByMainSystem).forEach(resource => {
                this.formatDataToSubmit(resource);
                if (resource && resource.name && resource.name.includes(userConfig.RESOURCE_DISPATCH_BASIC)){
                  this.handleDataCandidateSpecial(dispatchBasic, resource);
                } else if (resource && resource.name && resource.name.includes(userConfig.RESOURCE_DISPATCH_INSURANCE)){
                  this.handleDataCandidateSpecial(dispatchInsurance, resource);
                } else {
                  if (this.TYPE_OF_SINGLE_SELECT.includes(resource.type) || this.TYPE_OF_MULTI_SELECT.includes(resource.type)) {
                    dataCandidate.candidate[`${resource.name}`] = resource.value;
                  } else {
                    dataCandidate.candidate[`${resource.name}`] = `${resource.default_value}`;
                  }
                }
              })
          );
        }
      });
      if(Object.keys(dispatchBasic).length > 0){
        dataCandidate.candidate.dispatch_basic= dispatchBasic;
      }

      if(Object.keys(dispatchInsurance).length > 0){
        dataCandidate.candidate.dispatch_insurance= dispatchInsurance;
      }

      if(this.displaySetting && this.displaySetting.inHouseHP){
        dataCandidate.candidate['medium_id'] = this.displaySetting.inHouseHP;
      }

      if (dataCandidate.candidate.careers && Object.keys(dataCandidate.candidate.careers[0]).length === 0) {
        delete dataCandidate.candidate.careers;
      }

      if (dataCandidate.candidate.educations && Object.keys(dataCandidate.candidate.educations[0]).length === 0) {
        delete dataCandidate.candidate.educations;
      }

      if(Object.keys(dataCandidate.candidate).length === 0){
        this.isLoadingData = false;
        return;
      }
      Vue.$toast.clear();
      let messagesError = [];
      await userService.postCandidatesToMatchingood2nd(dataCandidate, hash).then(response => {
        if (response.data.code === 200 && response.data.result.candidate.id) {
          this.candidateId = response.data.result.candidate.id;
          this.submitCandidateSucces = true;
          Vue.$toast.success(
            entrySettingNotificationProperty.REGISTER_SUCCESSFULLY, {
              position: "bottom-right",
                duration: 3000,
              }
          );
        }
      }).catch(e => {
        this.submitCandidateSucces = false;
        console.log(e);
        if(e.response && e.response.data && e.response.data.code === 400 && e.response.data.messages.length > 0){
          e.response.data.messages.filter(m => m && m.message && m.rule && m.column_display_name).forEach(m =>{
            messagesError.push(m.column_display_name + ": " + m.message);
          })
          if(messagesError.length > 1){
            messagesError.push(configProperties.LINE);
            messagesError.push(configProperties.NOTIFY_UPDATE_ITEM_SETTING);
          }
        }else{
          messagesError.push(JSON.stringify(e.response.data));
          messagesError.push(configProperties.LINE);
          messagesError.push(configProperties.CONTACT_MANAGER);
        }
        if (this.message.messageError) {
          Vue.$toast.error(entrySettingNotificationProperty.REGISTER_FAIL, {
                position: "bottom-right",
                duration: 3000,
              }
          );
        }
      });

      await this.getJobDetail(hash);
      await this.createProcess(hash);
      if ((this.photo || this.files.filter((file) => file.content).length > 0)  && this.submitCandidateSucces) {
        await this.handleSubmitPhotoOrFiles(hash);
      }

      let keyInBodyMails = [];
      const regex = /{{([\w]+)}}/g;
      if (this.autoMailReply.emailBody.match(regex)) {
        keyInBodyMails = this.autoMailReply.emailBody.match(regex).filter(key => key && key.length > 4 && key.includes("{{"));
      }
      let staffId = 0;
      let companyId = 0;
      if(keyInBodyMails.length > 0){
        keyInBodyMails.forEach(key => {
          this.replaceMailSetting.filter(setting => setting.keyReplace === key).forEach(setting => {
            if (setting.itemReplace.startsWith(entrySettingProperty.ITEM_ENTRY_MODIFY)) {
              setting.itemReplace = setting.itemReplace.substring(entrySettingProperty.ITEM_ENTRY_MODIFY.length, setting.itemReplace.length);
            } else if (setting.itemReplace.startsWith(entrySettingProperty.ITEM_JOB_MODIFY)) {
              setting.itemReplace = setting.itemReplace.substring(entrySettingProperty.ITEM_JOB_MODIFY.length, setting.itemReplace.length);
            } else if (setting.itemReplace.startsWith(entrySettingProperty.ITEM_DISPATCH_JOB_MODIFY)) {
              setting.itemReplace = setting.itemReplace.substring(entrySettingProperty.ITEM_DISPATCH_JOB_MODIFY.length, setting.itemReplace.length);
            }

            if (this.jobDetail.hasOwnProperty(setting.itemReplace)) {
              if(setting.itemReplace === 'staff_id'){
                if(this.jobDetail[setting.itemReplace]){
                  staffId = this.jobDetail[setting.itemReplace];
                }
              }
              if(setting.itemReplace === 'company_id'){
                if(this.jobDetail[setting.itemReplace]){
                  companyId = this.jobDetail[setting.itemReplace];
                }
              }
            }
          });
        });
      }
      if(staffId > 0){
        await this.getStaff(staffId, hash);
      }
      if(companyId > 0){
        await this.getCompany(companyId, hash);
      }

      await this.createEmail(hash, messagesError);

      if (this.submitCandidateSucces) {
        if (this.emailToCandidate.to && this.emailToCandidate.to.length > 0 && this.emailToCandidate.from_address && this.emailToCandidate.user_id) {
          await this.sendEmailToCandidate(hash);
        }
        await this.sendEmailToManager(hash);
      } else {
        this.emailToManager.subject = this.notificationEmail.errorEmailTitle;
        await this.sendEmailToManager(hash);
      }
    },

    async createProcess(hash) {
      if (!this.displaySetting.progressStep || !this.displaySetting.manager || this.candidateId <= 0 || this.jobDetailId <= 0) {
        return;
      }

      let progress = {
        apply: {
          candidate_id: this.candidateId,
          job_id: this.jobDetailId,
          step: [
            {
              candidate_job_step_state_id: this.displaySetting.progressStep,
              // user_id: Number(process.env.VUE_APP_HP_USER_ID),
              user_id: this.displaySetting.manager,
              start_at: momenttz.tz(new Date(), Intl.DateTimeFormat().resolvedOptions().timeZone).format(),
            }
          ],
        },
      };
      let spotJob = this.jobDetail.dispatch_job_type_id ? this.jobDetail.dispatch_job_type_id : null;
      if(spotJob && spotJob === configProperties.DISPATCH_JOB_TYPE) progress.apply.step[0]["due_date"] = new moment(Date()).format("yyyy-MM-DD");

      await userService.createProcess(progress, hash).then(response => {
        if (response.status === 200) {
          this.submitCandidateSucces = true;
        }
      }).catch(e => {
        console.log(e);
        this.submitCandidateSucces = false;
      });
    },

    getSubItemValue(nameReource){
      if(!nameReource) return "";
      let origrinNameReource = nameReource.split('.');
      if(origrinNameReource.length > 1){
        let isValueObject = this.jobDetail[origrinNameReource[0]];
        if(Array.isArray(isValueObject)){
          let values = [];
          isValueObject.filter(value => value[origrinNameReource[1]]).forEach(value =>{
            values.push(value[origrinNameReource[1]]);
          });
          return values;
        }else if(isValueObject){
          return this.jobDetail[origrinNameReource[0]][origrinNameReource[1]];
        }else{
          return "";
        }
      }else if(this.jobDetail[nameReource]){
        return this.jobDetail[nameReource];
      }else{
        return "";
      }
    },

    settingMasterInfoAPI(field){
      let master = this.resourcesAPI.filter(resource_api => field.endsWith(resource_api.field))[0];
      if(!master) return;
      let value = this.getSubItemValue(field);
      if(value === "") return;
      let oldResource = this.masterApiData.filter(resource => resource && resource.master_name && resource.master_name === master.path)[0];
      value = Array.isArray(value) ? value : [value];
      if(oldResource){
        if(value){
          let newValue = [...oldResource.value,...value];
          oldResource.value = new Set(newValue);
        }
      }else{
        let dataMaster = {master_name: master.path, field: master.field, value: value};
        this.masterApiData.push(dataMaster);
      }
    },

    getValueFromApiMaster(key){
      if(!key) return "";
      let nameResource = key.includes('.')? key.split('.')[1]: key;
      let masterData = this.masterApiData.filter(master => master && master.field === nameResource)[0];
      if(!masterData || !masterData.data) return "";
      let value = this.getSubItemValue(key);
      if(!value) return "";
      if(Array.isArray(value)){
        let datas = masterData.data.filter(data => value.includes(data.id));
        let itemValues = [];
        datas.forEach(d => {
          itemValues.push(d.name);
        });
        return itemValues.join();
      }else{
        let data = masterData.data.filter(data => data.id === value)[0];
        return data && data.name ? data.name : "";
      }
    },

    async createEmail(hash, messagesError) {
      let toEmails = [];
      let candidateInfo = [];
      let itemsData = [];
      this.categories.filter(category => category.item && category.item.length > 0).forEach(category => {
        category.item.filter(item => item.resourceField && item.resourceField.length > 0).forEach(item => {
          item.resourceField.filter(resource => !resource.isDeletedByMainSystem && resource.type && resource.default_value && resource.type.includes("mail")).forEach(resource => {
            if (!toEmails.includes(resource.default_value)) {
              toEmails.push(resource.default_value);
            }
          });

          item.resourceField.filter(resource => !resource.isDeletedByMainSystem && resource.name).forEach(resource => {
            itemsData.push(resource);
            if(this.TYPE_OF_MULTI_SELECT.includes(resource.type) && resource.default_value && resource.default_value.length > 0){
              candidateInfo.push(`${item.itemName}` + ": " + this.formatDisplay(resource));
            }else if(!this.TYPE_OF_MULTI_SELECT.includes(resource.type) && resource.default_value){
              candidateInfo.push(`${item.itemName}` + ": " + this.formatDisplay(resource));
            }
          });
        });
      });

      if (toEmails.length === 0 && this.autoMailReply.emailAccounts.filter(emailAccount => emailAccount && !emailAccount.deletedDate).length <= 0) {
        return;
      }

      await this.getMasterApiData(hash);
      let bodyMail = "";
      let keyInBodyMails = [];
      const regex = /{{([\w]+)}}/g;
      if (this.autoMailReply.emailBody.match(regex)) {
        keyInBodyMails = this.autoMailReply.emailBody.match(regex).filter(key => key && key.length > 4 && key.includes("{{"));
      }

      bodyMail = this.autoMailReply.emailBody;
      let valueReplace = "";
      if (keyInBodyMails.length > 0) {
        keyInBodyMails.forEach(key => {
          this.replaceMailSetting.filter(setting => setting.keyReplace === key).forEach(setting => {
            if (setting.itemReplace.startsWith(entrySettingProperty.ITEM_ENTRY_MODIFY)) {
              setting.itemReplace = setting.itemReplace.substring(entrySettingProperty.ITEM_ENTRY_MODIFY.length, setting.itemReplace.length);
            } else if (setting.itemReplace.startsWith(entrySettingProperty.ITEM_JOB_MODIFY)) {
              setting.itemReplace = setting.itemReplace.substring(entrySettingProperty.ITEM_JOB_MODIFY.length, setting.itemReplace.length);
            } else if (setting.itemReplace.startsWith(entrySettingProperty.ITEM_DISPATCH_JOB_MODIFY)) {
              setting.itemReplace = setting.itemReplace.substring(entrySettingProperty.ITEM_DISPATCH_JOB_MODIFY.length, setting.itemReplace.length);
            }

            let itemValue = this.getSubItemValue(setting.itemReplace);
            let itemJobDetailSetting = this.getItemSetting(setting.itemReplace);
            let origrinNameReource = setting.itemReplace.split('.');
            let propertyJob = origrinNameReource.length > 1 ? origrinNameReource[0] : setting.itemReplace;
            let keyResourceAPI = origrinNameReource.length > 1 ? origrinNameReource[1] : setting.itemReplace;
            if (this.jobDetail.hasOwnProperty(propertyJob) || itemValue) {
              if(setting.itemReplace === 'staff_id'){
                if(this.staff && this.staff.name){
                  valueReplace = this.staff.name;
                }else{
                  valueReplace = "";
                }
              }
              else if(setting.itemReplace === 'company_id'){
                if(this.company && this.company.name){
                  valueReplace = this.company.name;
                }else{
                  valueReplace = "";
                }
              }
              else if(this.resourcesAPI.filter(resource => resource && resource.field === keyResourceAPI).length > 0){
                valueReplace = this.getValueFromApiMaster(setting.itemReplace);
              }
              else{
                valueReplace = this.formatDisplayJobDetail(itemJobDetailSetting, itemValue);
              }
              bodyMail = bodyMail.replace(key, valueReplace);
            } else {
              itemsData.filter(item => item.name).forEach(item => {
                let originName = "";
                if (userConfig.RESOURCE_SPECIALS.includes(item.name.substring(0, item.name.indexOf(".")+ 1))) {
                  originName = item.name.substring(item.name.indexOf(".") + 1, item.name.length);
                }
                if(item.name === setting.itemReplace || originName === setting.itemReplace){
                  valueReplace = this.formatDisplay(item);
                  bodyMail = bodyMail.replace(key, valueReplace);
                }
              });
            }
          });
        });
      }

      this.emailToCandidate = {
        to: toEmails,
        from_address: this.autoMailReply.emailAccounts[0].emailAccount,
        subject: this.autoMailReply.emailTitle,
        body: bodyMail,
        user_id: this.autoMailReply.emailAccounts[0].userId
      };

      let emailManagers = [];
      if (!this.notificationEmail || this.notificationEmail.emailAccounts) {
        this.notificationEmail.emailAccounts.filter(email => email && email.emailAccount).forEach(email => emailManagers.push(email.emailAccount));
      }
      let sendBodyMail = configProperties.HEADER_MESSAGE_BODY_MAIL + configProperties.LINE;
      if(messagesError && messagesError.length > 0){
        sendBodyMail += candidateInfo.join("\n");
        sendBodyMail += "\n" + configProperties.DETAIL_ERROR + configProperties.LINE;
        sendBodyMail += messagesError.join("\n");
      }else{
        sendBodyMail = candidateInfo.join("\n");
      }
      this.emailToManager = {
        to: emailManagers,
        from_address: this.autoMailReply.emailAccounts[0].emailAccount,
        user_id: this.autoMailReply.emailAccounts[0].userId,
        subject: this.notificationEmail.emailTitle,
        body: sendBodyMail,
      };
    },

    getItemSetting(itemReplace){
      let item;
      this.itemsJobDetails.filter(category => category && category.item && category.item.length > 0).forEach(category =>{
        category.item.filter(itemDetail => itemDetail && itemDetail.resourceField && itemDetail.resourceField.length > 0).forEach(itemDetail =>{
          if(itemDetail.resourceField[0].name === itemReplace){
            item = itemDetail;
          }
        });
      })
      if(item){
        return item;
      }
    },

    async getMasterApiData(hash){
      if(this.jt === DISPATCH_DETAIL_FORM_TYPE && Array.isArray(this.itemsJobDetails) && this.itemsJobDetails.length > 0){
        this.itemsJobDetails.filter(category => category && category.item && category.item.length >0).forEach(category => {
          category.item.filter(item => item && item.resourceField && item.resourceField.length > 0).forEach(item => {
            item.resourceField.filter(resource => resource && resource.name && !resource.isDeletedByMainSystem 
              && !resource.name.startsWith(jobSettingProperty.ITEM_COMPANY_MODIFY)).forEach(resource => {
              this.settingMasterInfoAPI(resource.name);
            })
          })
        });
        await Promise.all([...this.masterApiData].map(async (masterApi) => {
          let ids = Array.from(masterApi.value);
          if(masterApi && ids.length > 0){
            await userService.getDispatchResourceData(masterApi.master_name, ids, hash).then(async response => {
              if(response.status === 200){
                let master = this.masterApiData.filter(master => master && master.master_name === masterApi.master_name)[0];
                if(master){
                  master['data'] = response.data;
                }
              }
            }).catch(e => {
              console.log(e);
            })
          }
        })).finally(()=>{
          this.isLoadingData = false;
        });
      }
    },

    async getStaff(id, hash) {
      await userService.getStaff(id, hash)
        .then(response => {
          if (response && response.data != null) {
            this.staff = response.data;
          }
        }).catch(e => {
          console.log(e);
        });
    },

    async getCompany(id, hash) {
      await userService.getCompany(id, hash)
        .then(response => {
          if (response && response.data != null) {
            this.company = response.data;
          }
        }).catch(e => {
          console.log(e);
        });
    },

    formatDisplay(resource) {
      let value = "";
      if (this.TYPE_OF_SINGLE_SELECT.includes(resource.type) && resource.name !== "sex_id" && resource.default_value && resource.default_value.show) {
        value = resource.default_value.choiceDisplayName ? resource.default_value.choiceDisplayName : resource.default_value.choiceName;
      } else if ((resource.type === "boolean" || resource.name === "sex_id") && resource.default_value && resource.default_value.show) {
        value = resource.default_value.choiceDisplayName ? resource.default_value.choiceDisplayName : resource.default_value.choiceName;
      } else if (this.TYPE_OF_MULTI_SELECT.includes(resource.type) && resource.default_value && resource.default_value.length > 0) {
        let optionValues = [];
        resource.default_value.filter(value => value.show).forEach(value => {
          if (value.choiceDisplayName) {
            optionValues.push(value.choiceDisplayName);
          } else {
            optionValues.push(value.choiceName);
          }
        });

        value = optionValues.join(", ");
      } else if (this.FORMAT_DATE.includes(resource.type) && resource.name !== "birth_date" && resource.default_value) {
        value = this.getDatetimeString(resource.type, resource.default_value);
      } else if (resource.name === "birth_date" && resource.type === "date" && resource.default_value) {
        let birthDate = new Date(resource.default_value);
        let yearString = birthDate.getYear() + 1900;
        yearString = yearString + labelsInputProperties.YEAR;
        let monthString = birthDate.getMonth() + 1;
        monthString = monthString + labelsInputProperties.MONTH;
        let dateString = birthDate.getDate();
        dateString = dateString + labelsInputProperties.DAY;
        value = yearString + monthString + dateString;
      } else if(resource.default_value){
        value = resource.default_value;
      }else{
        value = "";
      }
      value = resource.unit && value ? value + " " + resource.unit : value;
      return value;
    },

    checkHaveMasterData(key){
      let keys = key.split('.');
      if(keys.length > 1){
        let key = this.resourcesAPI.filter(f => f.field === keys[1]);
        return key.length <= 0;
      }else{
        let key = this.resourcesAPI.filter(f => f.field === keys[0]);
        return key.length <= 0;
      }
    },

    formatDisplayJobDetail(item, job ){
      if(!job || !item || !item.resourceField[0].type){
        return "";
      }
      let value = "";
      let typeOfData = item.resourceField[0].type;
      let unit = item.resourceField[0].unit;
      if (this.TYPE_OF_SINGLE_SELECT.includes(typeOfData) && job) {
        if(this.checkHaveMasterData(item.resourceField[0].name) && item.resourceField[0].master_name){
          let masterData = this.masters[item.resourceField[0].master_name].items.find(item => item.choiceId === job);
          if (masterData){
            if(masterData.choiceDisplayName){
              value = masterData.choiceDisplayName;
            }else if(masterData.choiceName){
              value = masterData.choiceName;
            }else{
              value = "";
            }
          }
        }else{
          value = this.getValueFromApiMaster(item.resourceField[0].name);
        }
      } else if (this.TYPE_OF_MULTI_SELECT.includes(typeOfData) && job) {
        if(this.checkHaveMasterData(item.resourceField[0].name) && job.length > 0 && item.resourceField[0].master_name){
          let optionValues = [];
          job.forEach(jobId => {
            let choice = this.masters[item.resourceField[0].master_name].items.find(item => item.choiceId === jobId);
            if (choice.choiceDisplayName) {
              optionValues.push(choice.choiceDisplayName);
            } else {
              optionValues.push(choice.choiceName);
            }
          })
          if(optionValues.length > 0){
            value = optionValues.join(", ");
          }
        }else{
          value = this.getValueFromApiMaster(item.resourceField[0].name);
        }
      } else if (this.FORMAT_DATE.includes(typeOfData) && job) {
        value = this.getDatetimeString(typeOfData, job);
      }else if (this.TYPE_OF_NUMBER.includes(typeOfData) && job) {
        value = this.formatNumberByStep(job, item.resourceField[0].step);
      }else {
        value = job;
      }
      value = value && unit ? value + " " + unit : value;
      return value;
    },

    async sendEmailToCandidate(hash) {
      await userService.sendEmail(this.emailToCandidate, hash).then(response => {
        if (response.status === 200) {
          return true;
        }
      }).catch(e => {
        Utils.responsePageMaintenance(e);
        return false;
      });
    },

    async sendEmailToManager(hash) {
      if (!this.emailToManager.to || this.emailToManager.to.length <= 0) {
        this.isLoadingData = false;
        return;
      }
      await userService.sendEmail(this.emailToManager, hash).then(response => {
        if (response.status === 200) {
          return true;
        }
      }).catch(e => {
        Utils.responsePageMaintenance(e);
        return false;
      }).finally(()=>{
        this.isLoadingData = false;
      })
    },

    async getJobDetail(hash) {
      this.jobDetail = {};
      if (!this.jobDetailId || this.jobDetailId <= 0) {
        return;
      }

      if(this.jt === DISPATCH_DETAIL_FORM_TYPE) {
        await userService.getDispatchJobDetail(this.jobDetailId, hash).then(response => {
          if (response.status === 200) {
            this.jobDetail = response.data;
          }
        }).catch(e => {
          Utils.responsePageMaintenance(e);
          return;
        });
      } else {
        await userService.getJobDetail(this.jobDetailId, hash).then(response => {
          if (response.status === 200) {
            this.jobDetail = response.data;
          }
        }).catch(e => {
          Utils.responsePageMaintenance(e);
          return;
        });
      }
    },

    formatDataToSubmit(resource) {
      let choices = [];
      switch (resource.type) {
        case "date":
          resource.default_value = moment(resource.default_value).format("YYYY-MM-DD");
          break;
        case "datetime":
          resource.default_value = moment(resource.default_value).format("YYYY-MM-DDThh:mm:ss+zHH:zMM");
          break;
        case "ym":
          resource.default_value = moment(resource.default_value).format("YYYY-MM");
          resource.default_value += "-01";
          break;
        case "time":
          resource.default_value = moment(resource.default_value).format("HH:mm:ss");
          break;
        case "single_select":
          resource.value = resource.default_value.choiceId ? resource.default_value.choiceId: "" ;
          break;
        case "select":
          resource.value = resource.default_value.choiceId ? resource.default_value.choiceId: "" ;
          break;
        case "radio":
          resource.value = resource.default_value.choiceId ? resource.default_value.choiceId: "" ;
          break;
        case "boolean":
          resource.value = resource.default_value ? resource.default_value.choiceId: "";
          break;
        case "multi_select":
          resource.default_value.filter(value => value && value.choiceId && !choices.includes(value.choiceId)).forEach(value => choices.push(value.choiceId));
          resource.value = choices;
          break;
        case "checkbox":
          resource.default_value.filter(value => value && value.choiceId && !choices.includes(value.choiceId)).forEach(value => choices.push(value.choiceId));
          resource.value = choices;
          break;
      }

      return resource;
    },

    async handleSubmitPhotoOrFiles(hash) {
      await this.handleSubmitPhoto(hash);
      await this.handleSubmitFiles(hash);
    },

    async handleSubmitPhoto(hash) {
      if (!this.photo) {
        return;
      }
      await this.convertFileToBase64(this.photo).then(data => this.photoBase64 = data);

      if (!this.photoBase64) {
        return;
      }

      let photoData = {
        resource_name: "candidate",
        resource_id: this.candidateId,
        usage: "photo",
        file_name: this.photo.name,
        file_data: this.photoBase64,
      };

      await userService.postCandidateAttachmentToMatchingood2nd(photoData, hash).then(response => {
        if (response.code === 200) {
          this.submitCandidateSucces = true;
        }
      }).catch(e => {
        this.submitCandidateSucces = false;
        Utils.responsePageMaintenance(e);
      });
    },

    async handleSubmitFiles(hash) {
      if (this.files.filter((file) => file.content).length < 0) {
        return;
      }
      for (const file of this.files.filter(file => file && file.content && file.content.name)) {
        await this.convertFileToBase64(file.content).then(data => file.fileBase64 = data);
        if (!file.fileBase64) {
          continue;
        }

        let fileData = {
          resource_name: "candidate",
          resource_id: this.candidateId,
          usage: "file",
          file_name: file.content.name,
          file_data: file.fileBase64,
        };

        userService.postCandidateAttachmentToMatchingood2nd(fileData, hash).then(response => {
          if (response.code === 200) {
            this.submitCandidateSucces = true;
          }
        }).catch(e => {
          this.submitCandidateSucces = false;
          Utils.responsePageMaintenance(e);
        });
      }
    },

    async convertFileToBase64(file) {
      if (!file || file.size === 0) return " ";
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.slice(reader.result.indexOf(",") + 1));
        reader.onerror = (error) => reject(error);
      });
    },

    handleBindDate() {
      if (!this.categories) {
        return;
      }

      this.categories.filter(category => category.item && category.item.length > 0).forEach(category =>
          category.item.filter(item => item.resourceField && item.resourceField.length > 0).forEach(item =>
              item.resourceField.filter(resource => !resource.isDeletedByMainSystem && resource.type === "date" && resource.name === "birth_date" && resource.default_value).forEach(resource => {
                const date = new Date(resource.default_value);
                this.year = date.getYear() + 1900;
                this.month = date.getMonth() + 1;
                this.day = date.getDate();
              })
          )
      );
    },

    validatorInput() {
      if (!this.categories) {
        return;
      }

      this.categories.filter(category => category.item && category.item.length > 0 && !category.categoryDeleted).forEach(category =>
        category.item.filter(item => item.itemRequired && !item.itemDeleted).forEach(item =>
            item.resourceField.filter(resource => resource.type !== "blank" && !resource.isDeletedByMainSystem).forEach(resource => {
              let isEmptyValue = false;
              if(resource.name !== 'files' && resource.name !== 'photo'){
                isEmptyValue = !resource.default_value || resource.default_value === "" || resource.default_value.length === 0;
              }
              let isEmptyPhoto = resource.name === 'photo' && !this.photo;
              let isEmptyFiles = resource.name === 'files' && this.files.filter(file => file && file.content).length === 0;

              if (isEmptyValue || isEmptyPhoto || isEmptyFiles) {
                if (this.messages.includes(item.itemName)) {
                  return;
                }

                this.messages.push(item.itemName);
              }
            }
          )
        )
      );

      return this.messages.length <= 0;
    },

    getMasterData(master_name) {
      for (const master in this.masters) {
        if (master === master_name) {
          return [...this.masters[master].items];
        }
      }
    },

    buildListItem(resourceField) {
      let result = [];
      resourceField.forEach(field => {
        if (!result || !result[field.itemDisplayOrder]) {
          result[field.itemDisplayOrder] = [field];
        } else if (result[field.itemDisplayOrder]) {
          result[field.itemDisplayOrder].push(field);
        }
      });

      return result;
    },

    checkCategoryItemsLength(index) {
      let length = 0;
      this.categories[index].item.forEach(i => {
        if (i.itemDeleted === undefined || i.itemDeleted === false) {
          length++;
        }
      });

      return length;
    },

    checkPropertyCategory(categoryIndex) {
      let propertyCategory = "";
      if (this.checkCategoryItemsLength(categoryIndex) !== 0) {
        for (let i = 0; i < this.categories[categoryIndex].item.length; i++) {
          if (this.categories[categoryIndex].item[i].itemDeleted) {
            continue;
          }

          let firstResourceName = this.categories[categoryIndex].item[i].resourceField.find(resource => resource.itemDisplayOrder === 0 && resource.itemColumn === 0).name;
          if (firstResourceName.includes("educations.")) {
            propertyCategory = "educations";
            break;
          }

          if (firstResourceName.includes("careers.")) {
            propertyCategory = "careers";
            break;
          }
        }
      }

      return propertyCategory;
    },

    duplicateCategory(index) {
      if (!this.categories[index].countCate) {
        this.categories[index].countCate = 1;
      }

      let newCategory = JSON.parse(JSON.stringify(this.categories[index]));
      newCategory.item.forEach(i => i.resourceField.forEach(resource => resource.default_value = ""));
      newCategory.countCate = this.categories[index].countCate + 1;
      this.categories.splice(index + 1, 0, newCategory);
    },

    findLastCategoryIndex(groupType) {
      let count = -1;
      this.categories.forEach((_, i) => {
        if (this.checkPropertyCategory(i) === groupType) {
          count = i;
        }
      });

      return count;
    },

    async backToJobDetail(jobId) {
      await this.$emit("createLogger", this.startActionLog + labelProperties.BUTTON_BACK_TO_JOB_DETAIL);
      let url = window.location.origin + "?c=" + encodeURIComponent(this.encryptJobCode) + "&jid=" + jobId + "&query=" + encodeURIComponent(this.keyRedisSearch);
      if(this.jt) {
        url += "&jt=" + this.jt;
      }
      window.location = url;
      this.onTopOfIframe();
    },

    onTopPage() {
      document.body.scrollTop = 0;
    },

    getPageStatus() {
      authService.getScreenStatus().then(screenStatusResponse => {
        if (Number(screenStatusResponse.data.is_iframe_application_entry) !== 1) {
          this.$router.push("/404");
        }
      }).catch(e => {
        Utils.responsePageMaintenance(e);
      });
    },

    printPage() {
      this.$emit("printPage");
    }
  },
};
</script>
<style scoped>
.entry_stepbar_item:not(:last-child)::after {
  border-left-color: var(--keyColor) !important;
}

.message_confirm {
  text-align: center !important;
  min-height: 130px !important;
}

.message_complete {
  text-align: center !important;
  min-height: 200px !important;
}

.break-word {
  word-break: break-all !important;
}

@media screen and (max-width: 768px) {
  .title-default {
    display: none;
  }

  .title-mobile {
    display: inline;
  }
}

@media screen and (min-width: 769px) {
  .title-default {
    display: inline;
  }

  .title-mobile {
    display: none;
  }
}

.customize_setting_entry_confirm {
  word-break: break-all;
  white-space: pre-wrap;
}

.pre-margin-bottom{
  margin-bottom: 0 !important;
}

.overlay_setting{
  background-color: rgba(223, 222, 222, 0.6) !important;
}

.jobs_page_title_preview {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 15px !important;
}

.jobs_table_annotation_preview {
  margin-top: 8px;
  font-size: 14px;
  margin-bottom: 12px !important;
  white-space: break-spaces;
}
.jobs_page_title{
  margin-bottom: 12px !important;
}

.setting_botton_top{
  position: absolute;
  bottom: calc(100vh/4);
  right: 0.5rem;
  height: 50px;
  padding: 16px;
  display: none;
  z-index: 1;
  font-size: 120%;
  font-weight: bold;
}

.setting_btn_print{
  position: absolute;
  top: 0px;
  right: 0.5rem;
  height: 50px;
  padding: 16px;
  display: block;
  z-index: 1;
  font-size: 120%;
  font-weight: bold;
}
</style>
